module.exports = __webpack_public_path__ + "img/TZ.85fd7d65.svg";